module.exports = __webpack_public_path__ + "static/Karla-Bold-b45be274b8b65fc9c72b038d72486edd.ttf";